import { IMobilePortfolioContentProps } from './MobilePortfolio.t';
import { FormGroup } from 'react-bootstrap';
import MobilePortfolioBannerCarousel from '../MobilePortfolioBannerCarousel';
import MobileAccountBox from '../../MobileAccountBox/MobileAccountBox';
import WithdrawalUnfinishedTransaction
    from '../../../../modules/Withdrawal/components/WithdrawalUnfinishedTransaction/WithdrawalUnfinishedTransaction';
import AchievementProgress from '../../../../modules/Achievements/components/AchievementProgress';
import LiteTradePortfolio from '../../../../modules/LiteTrade/components/LiteTradePortfolio/LiteTradePortfolio';
import React from 'react';
import { useSelector } from 'react-redux';
import {
    getIsShowPortfolioAchievementProgressSelector,
    getIsShowPortfolioBannerCarouselSelector,
    getIsShowPortfolioLastViewedAssetsSelector,
    getIsShowPortfolioSelectAssetBannerSelector,
    getIsShowPortfolioToRealAccountBannerSelector,
    getIsShowPortfolioTutorialListWidgetSelector,
} from '../mobilePortfolioSelectors';
import ToRealAccountBanner from '../../../../modules/Banners/ToRealAccountBanner/ToRealAccountBanner';
import SelectAssetBanner from '../../../../modules/Banners/SelectAssetBanner/SelectAssetBanner';
import LiteTradePortfolioLastViewed
    from '../../../../modules/LiteTrade/components/LiteTradePortfolio/LIteTradePortfolioLastViewed/LiteTradePortfolioLastViewed';
import TutorialListWidget from '../../../../modules/Tutorials/components/TutorialListWidget/TutorialListWidget';
import DemoLimitsProgress from '../../../../modules/DemoLimits/components/DemoLimitsProgress';
import IncompleteDepositWidget from '../../../../modules/IncompleteDeposit/IncompleteDepositWidget';

function MobilePortfolioContent(props: IMobilePortfolioContentProps) {
    const { handleSelectPosition, handleSelectOrder, handleSelectAsset } = props;
    const isShowPortfolioToRealAccountBanner = useSelector(getIsShowPortfolioToRealAccountBannerSelector);
    const isShowPortfolioSelectAssetBanner = useSelector(getIsShowPortfolioSelectAssetBannerSelector);
    const isShowTutorialListWidget = useSelector(getIsShowPortfolioTutorialListWidgetSelector);
    const isShownPortfolioBannerCarousel = useSelector(getIsShowPortfolioBannerCarouselSelector);
    const isShowPortfolioLastViewedAssetsSelector = useSelector(getIsShowPortfolioLastViewedAssetsSelector);
    const isShowPortfolioAchievementProgressSelector = useSelector(getIsShowPortfolioAchievementProgressSelector);

    return <div className={'MobilePortfolioContent'}>
        <FormGroup className={'mb-3'}>
            <MobileAccountBox/>
        </FormGroup>
        <DemoLimitsProgress className={'mb-3'}/>
        {isShownPortfolioBannerCarousel && <MobilePortfolioBannerCarousel className={'mb-3'}/>}
        <IncompleteDepositWidget className={'my-3'}/>
        <ToRealAccountBanner className={'mb-3'} showBanner={isShowPortfolioToRealAccountBanner}/>
        {
            isShowPortfolioSelectAssetBanner && <FormGroup className={'mb-3'}>
                <SelectAssetBanner onClick={handleSelectAsset}/>
            </FormGroup>
        }
        <WithdrawalUnfinishedTransaction/>
        {isShowPortfolioLastViewedAssetsSelector && <LiteTradePortfolioLastViewed/>}
        {isShowPortfolioAchievementProgressSelector && <AchievementProgress/>}
        <LiteTradePortfolio
            fromComponentName={'portfolio'}
            onSelectPosition={handleSelectPosition}
            onSelectOrder={handleSelectOrder}
        />
        {isShowTutorialListWidget && <TutorialListWidget showHeader className={'mt-3'}/>}
    </div>;
}

export default MobilePortfolioContent;
